module.exports = __webpack_public_path__ + "img/2658532-09-1.a1cdaab4.png";